/**
 * PtAtcudSeries API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createPtAtcudSeries,
  getActivePtAtcudSeries,
  getPtAtcudSeries,
  listPtAtcudSeries,
} from "../generated/pt-atcud-series/pt-atcud-series";

import { wrapListMethod, wrapMethod } from "./utils";

export const ptAtcudSeries = {
  /** @see createPtAtcudSeries */
  create: wrapMethod(createPtAtcudSeries),

  /** @see listPtAtcudSeries */
  list: wrapListMethod(listPtAtcudSeries),

  /** @see getPtAtcudSeries */
  get: wrapMethod(getPtAtcudSeries),

  /** @see getActivePtAtcudSeries */
  getActive: wrapMethod(getActivePtAtcudSeries),
} as const;

export type PtAtcudSeriesApi = typeof ptAtcudSeries;
